import { Component, Input } from '@angular/core';
import isEmpty from 'lodash-es/isEmpty';
import Highcharts from 'highcharts';

@Component({
  selector: 'app-post-trade-chart',
  templateUrl: './post-trade-chart.component.html',
  styleUrls: ['./post-trade-chart.component.scss'],
  standalone: false,
})
export class PostTradeChartComponent {
  @Input() chart;
  Highcharts: typeof Highcharts = Highcharts;
  isEmpty = isEmpty;

  returnZero() {
    return 0;
  }
}
